module.exports = __webpack_public_path__ + "static/Maanav.03cb743e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/team/Maanav.jpg
// module id = 1309
// module chunks = 137408898365125